export default __webpack_public_path__ + "static/media/step_08.3dc2188b.png";